import React from 'react';
import PropTypes from 'prop-types';
import styles from './ExportSection.module.scss';
import { connect } from 'dva';
import actions from './actions';
import { EXPORT_TYPE } from '../../../../lib/constants';

export function ExportSection(props) {
  return (
    <div className={styles.container}>
      <h2 className={styles.sectionHeader}>Export your map items</h2>
      <p className={styles.description}>
        Depending on how many items you are exporting, this can take a few
        seconds or even a few minutes. GPX format only supports waypoints and tracks.
      </p>
      <div className={styles.exportLinks}>
        {props.isExporting ? (
          <>
            <p className={styles.exportInProgress}>Export in progress...</p>
          </>
        ) : (
          <>
            <a
              onClick={props.exportAllFeatures(EXPORT_TYPE.KML)}
              className={`${styles.exportLink} ` + (props.isImporting ? `${styles.disabled}` : '')}
            >
              Export all as .KML
            </a>
            <a
              onClick={props.exportAllFeatures(EXPORT_TYPE.GPX)}
              className={`${styles.exportLink} ` + (props.isImporting ? `${styles.disabled}` : '')}
            >
              Export all as .GPX
            </a>
          </>
        )}
      </div>
    </div>
  );
}

ExportSection.propTypes = {
  isExporting: PropTypes.bool,
  isImporting: PropTypes.bool,
  //actions
  exportAllFeatures: PropTypes.func,
};

export default connect(
  (model) => ({
    isExporting: model.dataManager.isExporting,
    isImporting: model.dataManager.isImporting,
  }),
  actions
)(ExportSection);
